import { format } from "date-fns";
import { ptBR } from "date-fns/locale/pt-BR";
import { LuPencilLine } from "react-icons/lu";

import "./style.scss";
import { useAuth } from "context/AuthContext";
import { useEffect, useState } from "react";
import { useModal } from "context/ModalContext/Modal.context";
import { GrDownload } from "react-icons/gr";
import { FaPlay } from "react-icons/fa6";


import ModalParticipants from "./Modal/Participants";
import { Realization, RealizationSubscribed } from "types/realization";
import {
  clearRegistrationUser,
  isRealization,
  isRealizationSubscribed,
} from "utils/fns";
import Spinner from "../Spinner";
import { useNavigate } from "react-router";
import { getConfirmedPlayers } from "services/realization.service";

interface Options {
  data: Realization | RealizationSubscribed;
  type: "SUBSCRIPTION" | "CONFIRM";
  isLoading?: boolean;
  onNext: () => void;
}

const Card = ({ data, isLoading, type, onNext }: Options) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isMy, setIsMy] = useState(false);
  const { showModal } = useModal();
  const [confirmedPlayerList, setConfirmedPlayerList] = useState<any>([]);

  const [isCompetitor, setIsCompetitor] = useState(false);

  const viewParticipants = () => {
    showModal(
      "view-participants",
      <ModalParticipants
        data={data}
        confirmedPlayerList={confirmedPlayerList}
      />,
      "participants"
    );
  };

  useEffect(() => {
    if (!!user) {
      if (isRealizationSubscribed(data)) {
        setIsMy(
          clearRegistrationUser(user?._id) === data.inscricao.player ||
            user?._id === data.realization.owner ||
            data.realization.evaluator.includes(
              clearRegistrationUser(user?._id)
            ) ||
            data.realization?.original_manager ===
              clearRegistrationUser(user?._id)
        );
      }
    }
  }, [user]);

  useEffect(() => {
    if (isRealizationSubscribed(data)) {
      if (!!user) {
        console.log("check", data.player !== clearRegistrationUser(user?._id));
        if (data.player !== clearRegistrationUser(user?._id)) {
          setIsCompetitor(true);
        }
      }
    }
  }, [data]);

  async function getConfirmedList(idRealization: string) {
    const list = await getConfirmedPlayers(idRealization);
    setConfirmedPlayerList(list);
  }

  useEffect(() => {
    if (type === "CONFIRM" && isRealizationSubscribed(data)) {
      getConfirmedList(data.id_realizacao);
    }
  }, [data, type]);

  const handlerEdit = async (item: RealizationSubscribed) => {
    try {
      console.log(isMy);
      item = { ...item, ...{ allowNextButton: true, isMy: isMy } };
      console.log(item);
      if (!isMy) {
        navigate("/realizations/subscribe", {
          state: { data: item, action: "indication" },
        });
      } else {
        navigate("/realizations/subscribe", { state: { data: item } });
      }
    } catch (e) {}
  };

  return (
    <>
      <article className="flex flex-col card">
        {isRealization(data) && (
          <>
            <div className={`tag flex justify-end`}>
              {data.category && <span>{String(data.category)}</span>}
            </div>
            <h2 className="mb-2 mt-3 text-lg font-medium font-bb text-black-bb">
              <strong>Realização: </strong>
              {data.title}
            </h2>

            <div className="flex-1 p-4 detail bg-gray-bb-3">
              <p className="text-sm font-bold text-black-bb">
                <strong>Cadastrado por</strong>
              </p>
              <p>
                {data.owner_data.nome_guerra} ({data.owner_data.chave}), em{" "}
                {format(data.created, "dd 'de' MMMM 'de' yyyy", {
                  locale: ptBR,
                })}
              </p>

              <p className="mt-4 text-sm font-bold text-black-bb">
                <strong>Detalhes da realização</strong>
              </p>
              <p dangerouslySetInnerHTML={{ __html: data.description }} />
            </div>

            <div className="flex flex-col items-center justify-center gap-4 mt-4">
              <button
                className="px-4 py-3 font-bold uppercase text-blue-bb"
                onClick={viewParticipants}
              >
                Ver mais{" "}
              </button>
              <button
                className="px-4 py-3 font-bold uppercase rounded-md bg-yellow-bb text-blue-bb"
                onClick={onNext}
              >
                {isLoading ? "Aguarde..." : "Inscrever realização"}
              </button>
            </div>
          </>
        )}
        {isRealizationSubscribed(data) && (
          <>
            <div
              className={`flex ${
                isMy ? "justify-between" : "justify-end items-end"
              }`}
            >
              {isMy && (
                <button
                  className="flex items-center gap-1 font-semibold border-none background-none text-blue-bb"
                  onClick={(e) => handlerEdit(data)}
                >
                  <LuPencilLine size={24} /> Editar
                </button>
              )}
              <div className="tag">
                {data.category && <span>{String(data.category)}</span>}
              </div>
            </div>
            <h2 className="mb-2 mt-3 text-lg font-medium font-bb text-black-bb">
              <strong>Realização: </strong>
              {data.realization.title}
            </h2>

            <div className="flex-1 p-4 detail bg-gray-bb-3">
              <p className="mb-2 text-sm font-bold text-black-bb">
                <strong>Cadastrado por</strong>
              </p>
              <p>
                {data.realization.owner_data.nome_guerra} (
                {data.realization.owner_data.chave}), em{" "}
                {format(data.realization.created, "dd 'de' MMMM 'de' yyyy", {
                  locale: ptBR,
                })}
              </p>

              {!!data.player_indication_data && (
                <>
                  <p className="mt-2 mb-2 text-sm font-bold text-black-bb">
                    <strong>Inscrito por:</strong>
                  </p>
                  <p>
                    {data?.player_indication_data[0].nome_guerra} (
                    {data?.player_indication_data[0].chave})
                  </p>
                </>
              )}

              <p className="mt-2 mb-2 text-sm font-bold text-black-bb">
                <strong>Detalhes da realização</strong>
              </p>
              <p
                dangerouslySetInnerHTML={{
                  __html: data.realization.description,
                }}
              />

              {!!data.documento && data.documento.length > 0 ? (
                <>
                  <p className="mt-2 mb-2 text-sm font-bold text-black-bb">
                    <strong>Documentação complementar da realização</strong>
                  </p>
                  {data.documento.map((item) => (
                    <>
                      {!!item && item !== null && (
                        <>
                          {item.type === "video" ? (
                            <div className="relative mt-6">
                              <div className="flex items-start justify-center w-full">
                              </div>
                              <div>
                                <button>
                                  <a
                                    href={item.file}
                                    className="rounded-[4px] py-[14px] px-5 bg-gray-bb-2 text-white-bb-1 uppercase flex items-center gap-2 font-bold"
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    <FaPlay />
                                    Ver vídeo
                                  </a>
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div className="mt-6">
                              <button
                                className="rounded-[4px] py-[14px] px-5 bg-gray-bb-2 text-white-bb-1 uppercase flex items-center gap-2 font-bold"
                                onClick={() => {
                                  window.open(item.file, "_blank");
                                }}
                              >
                                <GrDownload size={22} />
                                Download
                              </button>
                            </div>
                          )}
                        </>
                      )}
                    </>
                  ))}
                </>
              ) : (
                <></>
              )}
            </div>

            <div className="flex flex-col items-center justify-center gap-4 mt-4">
              <button
                className="px-4 py-3 font-bold uppercase text-blue-bb"
                onClick={viewParticipants}
              >
                Ver mais{" "}
              </button>
              {data.concorrentes_info.length == 0 && !data.dt_aceite && (
                <button
                  className="px-4 py-3 font-bold uppercase rounded-md bg-yellow-bb text-blue-bb"
                  onClick={onNext}
                >
                  Confirmar participação
                </button>
              )}
            </div>
          </>
        )}
      </article>
    </>
  );
};

export default Card;
